export class InternalInfoClosePopupModel {
    public constructor(
        public title: string,
        public message: string,
        public yesMessage: string,
        public noMessage = '',
        public backMessage = '',
        public showYes = true,
    ) {}
}

export enum RESULT_TYPES {
    YES = 'YES',
    NO = 'NO',
    BACK = 'BACK',
}
